import React from "react";
import { get, isEmpty } from "lodash";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@material-ui/core";
import {
  displayData,
  getSegmentDurationString,
  getSegmentsTotalDuration,
} from "../../../utils/ContentFinderUtils";

const SegmentsSection = ({ segments, frameRate }) => {
  const orderedSegments = [...segments].sort(
    (a, b) => (a.startSeconds || 0) - (b.startSeconds || 0)
  );
  const segmentsFrameRate =
    frameRate || get(orderedSegments, "[0].editRate") || 24;
  const totalDuration = getSegmentsTotalDuration(
    orderedSegments,
    segmentsFrameRate
  );

  return (
    <section className="drawer-section">
      <h2 className="drawer-section-title">Segments</h2>
      <TableContainer
        component={Paper}
        className="content-finder-table-container drawer-table-container"
      >
        <Table className="content-finder-table content-finder-table--no-scroll">
          <TableHead className="tableHeader content-finder-table-head">
            <TableRow className="tableRow content-finder-header-row">
              {["Type", "In", "Out", "Duration"].map((header, i) => (
                <TableCell key={i} className="media-cell">
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="content-finder-table-body">
            {isEmpty(orderedSegments) ? (
              <TableRow className="tableRow content-finder-body-row">
                <TableCell
                  className="content-finder-table-cell drawer-empty-cell"
                  colSpan={4}
                >
                  No Segments Found
                </TableCell>
              </TableRow>
            ) : (
              orderedSegments.map((segment, i) => (
                <TableRow key={i} className="tableRow content-finder-body-row">
                  <TableCell className="content-finder-table-cell segment-bold-cell">
                    {displayData(get(segment, "type"))}
                  </TableCell>
                  <TableCell className="content-finder-table-cell">
                    {displayData(get(segment, "startTime"))}
                  </TableCell>
                  <TableCell className="content-finder-table-cell">
                    {displayData(get(segment, "stopTime"))}
                  </TableCell>
                  <TableCell className="content-finder-table-cell segment-bold-cell">
                    {getSegmentDurationString(segment, segmentsFrameRate)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {!isEmpty(orderedSegments) && (
        <Table className="content-finder-table content-finder-table--no-scroll segments-total-table">
          <TableBody>
            <TableRow className="content-finder-body-row segments-total-row">
              <TableCell className="segments-total-spacer" colSpan={2} />
              <TableCell className="segments-total-label">TOTAL:</TableCell>
              <TableCell className="segments-total-duration">
                {totalDuration}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </section>
  );
};

export default SegmentsSection;
